import { APIClient } from './APIClient';
import { HTTPClient, HTTPClientConfig } from './HTTPClient';

export class APIClientFactory {

    static inject = () => [
        HTTPClientConfig
    ]
    constructor(
        private httpClientConfig: HTTPClientConfig
    ){}

    getHTTPClient = ({ accessToken }: { accessToken?: string }) => {
        return new HTTPClient({ ...this.httpClientConfig, accessToken });
    };

    getAPIClient = ({ accessToken }: { accessToken?: string }) => {
        const httpClient = this.getHTTPClient({ accessToken });
        return new APIClient(httpClient);
    };
}
